import ListFactory from './ListFactory';

export default ListFactory;
